import React from "react";

export default function InputWebSiteUrl({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.website_url && "is-invalid"}`}
      type="text"
      placeholder="https://ejemplo.com"
      name="website_url"
      {...register("website_url", {
        pattern: {
          value: /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/.*)?$/,
          message: "La URL debe comenzar con http:// o https:// y ser válida",
        },
      })}
    />
  );
}
